import React from "react";
import { Button, Modal } from "react-bootstrap";

export default function BookingPatientConflictModal({ conflict, loading, onClose, onReload }) {
  const comparison = conflict && conflict.comparison;
  return (
    <Modal show={Boolean(comparison)} onHide={onClose} centered size="lg" backdrop="static" keyboard={!loading}>
      <Modal.Header closeButton={!loading}>
        <Modal.Title>Booking patient information changed</Modal.Title>
      </Modal.Header>
      {comparison && <Modal.Body>
        <p role="alert">
          {comparison.missing ? "This booking no longer exists." : "This booking was updated after you loaded it. Compare the patient information below."}
          {" "}<strong>Your changes have not been saved.</strong>
        </p>
        <p className="mb-2"><strong>Order:</strong> {comparison.order}</p>
        <div className="table-responsive">
          <table className="table table-sm table-bordered mb-0">
            <thead className="thead-light"><tr>
              <th scope="col">Field</th>
              <th scope="col">Booking you are editing</th>
              <th scope="col">Latest saved booking</th>
            </tr></thead>
            <tbody>{comparison.rows.map((row) => <tr key={row.label}>
              <th scope="row">{row.label}</th>
              <td className="text-break">{row.editingValue}</td>
              <td className={`text-break${row.changed ? " font-weight-bold text-primary" : ""}`}>
                {row.savedValue}{row.changed && <span className="badge badge-warning ml-2">Changed</span>}
              </td>
            </tr>)}</tbody>
          </table>
        </div>
        {!comparison.missing && <p className="mt-3 mb-2"><strong>Last updated by:</strong> {comparison.updatedBy}</p>}
        <p className="mb-0">Reload the latest booking to review it. Reloading discards the unsaved edits in this form.</p>
      </Modal.Body>}
      <Modal.Footer>
        <Button variant="secondary" disabled={loading} onClick={onClose}>Keep Editing</Button>
        <Button variant="primary" disabled={loading} onClick={onReload}>
          {loading ? "Reloading…" : "Reload Latest Booking"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
